import { createSelector } from 'reselect';
import { initialState } from './reducer';
var selectHelpModal = function (state) {
    return (state === null || state === void 0 ? void 0 : state.introModal) || initialState;
};
export var getHelpModalData = createSelector(selectHelpModal, function (helpData) {
    return helpData;
});
var selectWelcomeModal = function (state) {
    return (state === null || state === void 0 ? void 0 : state.introModal) || initialState;
};
export var getWelcomeModalData = createSelector(selectWelcomeModal, function (welcomeData) {
    return welcomeData;
});
